import RiskCategoryRow from './RiskCategoryRow'

export default RiskCategoryRow
